import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TIssueCategory } from '@monorepo/types';

@Component({
  selector: 'monorepo-issue-category-filter',
  templateUrl: './issue-category-filter.component.html',
  styleUrls: ['./issue-category-filter.component.scss'],
})
export class IssueCategoryFilterComponent implements OnInit {
  crossIcon = '/assets/common/cross-cancel-circular.svg';
  selectedCategoryVM: TIssueCategory | undefined;
  @Input() set selectedCategory(selectedCategory: TIssueCategory | undefined) {
    this.selectedCategoryVM = selectedCategory;
  }
  @Input() categoriesToShow: Set<TIssueCategory> = new Set<TIssueCategory>();
  @Output() changeCategory = new EventEmitter<TIssueCategory | undefined>();

  constructor() {}

  ngOnInit(): void {}

  onCategoryChange(category: TIssueCategory | undefined) {
    this.selectedCategoryVM = category;
    this.changeCategory.emit(category);
  }
}
